module.exports = __webpack_public_path__ + "static/media/Regulamin.12af8ea5.pdf";